import { render } from "./OrderNow.vue?vue&type=template&id=db99ec96"
import script from "./OrderNow.vue?vue&type=script&lang=js"
export * from "./OrderNow.vue?vue&type=script&lang=js"

import "./OrderNow.vue?vue&type=style&index=0&id=db99ec96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__